import changePoint from '@/vuex/modules/pointGroupOperation/mutationsUtil/changePoint'
import addNewPoint from '@/vuex/modules/pointGroupOperation/mutationsUtil/addNewPoint'
import deleteNewItem from '@/vuex/modules/pointGroupOperation/mutationsUtil/deleteNewItem'

import cloneDeep from 'lodash/cloneDeep'

const mutations = {
  SET_PAGE_PERMISSION(state, { pagePermission }) {
    state.editMode.pagePermission = pagePermission
  },
  SET_GROUP_LIST(state, { data }) {
    state.groupList = data
  },
  SET_TARGET_GROUP(state, { groupData }) {
    state.editMode.initialTargetGroup = cloneDeep(groupData)
    state.editMode.currentTargetGroup = cloneDeep(groupData)
    state.editMode.isEditingPoiCategory = false
  },
  SET_TARGET_GROUP_NOT_POINT(state, { groupData }) {
    state.editMode.initialTargetGroup = cloneDeep(groupData)
    state.editMode.currentTargetGroup = cloneDeep(groupData)
    state.editMode.isEditingPoiCategory = false
  },
  EDIT_GROUP_NAME(state, { name }) {
    state.editMode.currentTargetGroup.name = name
  },
  RESET_TARGET_GROUP(state) {
    state.editMode.initialTargetGroup = {
      id: null,
      name: null,
      locationType: null,
    }
    state.editMode.currentTargetGroup = {
      id: null,
      name: null,
      locationType: null,
    }
    state.editMode.isEditingPoiCategory = false
  },
  SET_IS_EDITING_POI_CATEGORY(state) {
    state.editMode.isEditingPoiCategory = true
  },
  SET_POINT_LIST_LOADING(state, loading) {
    state.editMode.loadingPointList = loading
  },
  SET_POINT_LIST_START(state, { data }) {
    state.editMode.initialPointList = data
    state.editMode.currentPointList = data
  },
  SET_INITIAL_POINT_LIST(state, { data }) {
    state.editMode.initialPointList = cloneDeep(data)
  },
  SET_CURRENT_POINT_LIST(state, { data }) {
    state.editMode.currentPointList = cloneDeep(data)
  },
  RESET_POINT_LIST(state) {
    state.editMode.initialPointList = []
    state.editMode.currentPointList = []
  },
  CHANGE_POINT(state, { data }) {
    state.editMode.currentPointList = changePoint(
      state.editMode.currentPointList,
      data,
    )
  },
  ADD_NEW_POINT(state, { data }) {
    state.editMode.currentPointList = addNewPoint(
      state.editMode.currentPointList,
      data,
    )
    state.editMode.newItemId++
  },
  DELETE_NEW_ITEM(state, { data }) {
    state.editMode.currentPointList = deleteNewItem(
      state.editMode.currentPointList,
      data,
    )
  },
  SET_SELECTED_POINT(state, { data }) {
    state.editMode.selectedPoint = cloneDeep(data)
  },
  SET_MAP_CENTER(state, { data, moveMap }) {
    if (!data) return
    const { shape } = data
    const { longitude, latitude } = shape
    if (moveMap) {
      state.editMode.mapCenter = {
        longitude,
        latitude,
      }
    }
  },
  SET_LAST_DRAG_END_TIME(state, lastDragEndTime) {
    state.editMode.lastDragEndTime = lastDragEndTime
  },
  INIT(state, initialState) {
    Object.keys(initialState).forEach(
      key => (state[key] = cloneDeep(initialState[key])),
    )
  },
  SET_MAP(state, map) {
    state.map = map
  },
  SET_MAP_LOADED(state, mapLoaded) {
    state.mapLoaded = mapLoaded
  },
  SET_POINT_LIST_IN_FRAME_COUNT(state, count) {
    state.pointListInFrameCount = count
  },
  SET_SEARCH_QUERY(state, query) {
    state.editMode.search.query = query
  },
  SET_SEARCH_RESULT_LIST(state, results) {
    state.editMode.search.resultList = [...results]
  },
  SET_SEARCH_RESULT_INDEX(state, index) {
    state.editMode.search.currentResultIndex = index
  },
  SET_FIT_BOUNDS(state, triggerOn) {
    state.fitBounds = triggerOn
  },
}

export default mutations
